import { render, staticRenderFns } from "./wpay-mypage.vue?vue&type=template&id=7d96a3ea&"
import script from "./wpay-mypage.vue?vue&type=script&lang=js&"
export * from "./wpay-mypage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports